var anime = require("animejs").default;

var Footer = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

Footer.prototype.init = function(){

  this.options.$el.find(".back-to-top").on("click", function(){

    anime({
      targets: 'html, body',
      scrollTop: 0,
      duration: 600,
      easing: "easeInOutQuart"
    });

  });

};

export default  Footer;
